export default class MapInstanceState {
    // state that's shared across interactions
    draggingWaypoint = false
}